<div style="text-align: center">
  <p style="font-size: 20px; margin-top: 10px"><a [href]="hotelURL">Click Here </a> to go back to Hotels website</p>
</div>
